import { render } from "./DexDetail.vue?vue&type=template&id=6640a16d&scoped=true"
import script from "./DexDetail.vue?vue&type=script&lang=js"
export * from "./DexDetail.vue?vue&type=script&lang=js"

import "./DexDetail.vue?vue&type=style&index=0&id=6640a16d&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6640a16d"],['__file',"resources/js/components/DexDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6640a16d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6640a16d', __exports__)) {
    api.reload('6640a16d', __exports__)
  }
  
  module.hot.accept("./DexDetail.vue?vue&type=template&id=6640a16d&scoped=true", () => {
    api.rerender('6640a16d', render)
  })

}


export default __exports__